import styled, { css } from 'styled-components';
import Tooltip from '../Tooltip';

interface ContainerProps {
  isFocused: boolean;
  isFilled: boolean;
  isErrored: boolean;
  hasTip?: string;
  isHidden: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  padding: 16px;

  width: 100%;
  height: 56px;
  margin-bottom: 16px;
  border: 2px solid #17171e;

  background: #2e2e35;
  border-radius: 10px;

  ${(props) =>
    props.isErrored &&
    css`
      border-color: #c80800;
    `}

  ${(props) =>
    props.isFocused &&
    css`
      color: #eea302;
      border-color: #eea302;
    `}

  ${(props) =>
    props.isFilled &&
    css`
      color: #eea302;
    `}

  ${(props) =>
    props.isHidden &&
    css`
      display: none;
    `}

  input {
    display: flex;
    align-items: center;
    justify-content: center;

    flex: 1;
    background: transparent;
    border: 0;

    color: #b8b8b8;
  }

  svg {
    margin-right: 8px;
  }
`;

export const Error = styled(Tooltip)`
  height: 20px;
  margin-left: 16px;

  svg {
    margin: 0;
  }

  span {
    background: #c53030;
    color: #fff;

    &::before {
      border-color: #c53030 transparent;
    }
  }
`;

export const Tip = styled(Tooltip)`
  height: 20px;
  margin-left: 16px;

  svg {
    margin: 0;
  }

  span {
    background: #eea302;
    color: #000;
    width: 200px;

    &::before {
      border-color: #eea302 transparent;
    }
  }
`;
